import { render, staticRenderFns } from "./DynamicModal.vue?vue&type=template&id=6b8a381e&scoped=true"
import script from "./DynamicModal.vue?vue&type=script&lang=js"
export * from "./DynamicModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8a381e",
  null
  
)

export default component.exports